import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import UIButton from 'UIComponents/button/UIButton';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { selectTeam, setDealSidebarOwnerId } from '../actions/OverviewDataActions';
import { toggleAggregatedDealRollupFetching, toggleAggregatedGoalsFetching } from '../actions/AggregatedOverviewDataActions';
import { trackNavigateByBreadcrumb } from '../utils/usageTracker';
import { TEAMS } from '../constants/OverviewConstants';
import { getIsDealStageView } from '../selectors/forecastSelectors';
import { getFilters } from '../selectors/filtersSelectors';
import { ForecastUsersPopover } from './filters/ForecastUsersPopover';
import { setQueryParams } from '../utils/filters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OverviewBreadcrumbs = ({
  breadcrumbTrail
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isDealStageView = useSelector(getIsDealStageView);
  const filters = useSelector(getFilters);
  const onBreadcrumbSelect = id => {
    dispatch(setDealSidebarOwnerId({
      dealSidebarId: null,
      isTeam: false
    }));
    dispatch(toggleAggregatedDealRollupFetching(true));
    dispatch(toggleAggregatedGoalsFetching(true));
    history.push(`/${TEAMS}/${id || ''}`);
    setQueryParams({
      history,
      filters
    });
    trackNavigateByBreadcrumb(isDealStageView);
    if (id) {
      dispatch(selectTeam(id));
    }
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsxs(UIBreadcrumbs, {
      singleBreadcrumbIsBackLink: false,
      flush: true,
      className: "m-top-2",
      children: [breadcrumbTrail.size ? /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "all-teams-link",
        use: "link",
        onClick: () => onBreadcrumbSelect(null),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "breadcrumbs.default"
        })
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "breadcrumbs.default"
      }), breadcrumbTrail.map(breadcrumb => {
        const title = breadcrumb.get('title');
        const id = breadcrumb.get('id');
        if (breadcrumbTrail.last().get('id') === id) {
          return /*#__PURE__*/_jsx("span", {
            "data-test-id": `breadcrumb-${title}`,
            children: title
          }, id);
        }
        return /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: () => onBreadcrumbSelect(id),
          "data-test-id": `breadcrumb-button-${title}`,
          children: title
        }, id);
      })]
    }), /*#__PURE__*/_jsx(ForecastUsersPopover, {
      isDetailPage: true
    })]
  });
};